import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";
import { useRecoilValue } from "recoil";
import Footer from "../components/Footer";
import MenuDesktopHorizontal from "../components/MenuDesktopHorizontal";
import OneCommentaire from "../components/OneCommentaire";
import SkeletonComment from "../components/SkeletonComment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { client } from "../client.js";
import { barreDefilement } from "../services/atom.js";

const LivreDOr = () => {
  const [allCommentaire, setAllCommentaire] = useState(null);
  const [commentaire, setCommentaire] = useState("");
  const [pseudo, setPseudo] = useState("");
  const [loadingBoutton, setLoadingBoutton] = useState(false);
  const hauteurScroll = useRecoilValue(barreDefilement);

  const scrollToTop = () => {
    const scrollContainer = document.querySelector(".overflow-scroll");

    scrollContainer?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // gerer les notification des commenatire envoyer
  const notify = () => {
    toast.success("Commenatire envoyer avec succès, Merci pour votre avis!!!", {
      position: "top-center",
      autoClose: 7000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const sendCommentaire = async (e) => {
    e.preventDefault();

    setLoadingBoutton(true);

    try {
      await client
        .create({
          _type: "commentaire",
          post: {
            _type: "reference",
            // _ref: _id,
          },
          commentaire,
          pseudo,
        })
        .then((response) => {
          setLoadingBoutton(false);
          notify();
        });
    } catch (err) {
      // return res.status(500).json({message: `Nous n'avons pas pu soumettre votre commentaire`, err})
    }
    // return res.status(200).json({ message: 'Commentaire envoyer avec succès.' })

    const comment = {
      pseudo: pseudo,
      commentaire: commentaire,
      _createdAtLocal: new Date().toLocaleString("fr-fr", {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "numeric",
      }),
    };

    setAllCommentaire((el) => [comment, ...el]);

    setCommentaire("");

    localStorage.setItem("pseudo", JSON.stringify(pseudo));
  };

  useEffect(() => {
    // l'appeler les commentaires
    client
      .fetch(
        `*[_type == "commentaire"]{
            _id,
            pseudo,
            commentaire,
            _createdAt,
          } | order(_createdAt desc)`
      )
      .then((data) => {
        setAllCommentaire(data);
      })
      .catch(console.error);

    const items = JSON.parse(localStorage.getItem("pseudo"));
    if (items) {
      setPseudo(items);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("pseudo", JSON.stringify(pseudo));
  }, [pseudo]);

  // useEffect(() => {

  // }, []);

  return (
    <div className="flex flex-col items-center w-full h-screen relative">
      <div className="flex flex-col relative w-full h-screen pb-40 lg:pb-6 px-8 lg:px-4 items-center max-w-2xl lg:max-w-4xl 2xl:max-w-6xl ecran-2000:max-w-7xl">
        <MenuDesktopHorizontal />

        <div className="pt-24 lg:pt-6 flex-1 flex flex-col items-center w-full text-white">
          <div className="flex flex-col items-center w-full space-y-8">
            <ToastContainer />
            <span
              style={{ marginTop: 0 }}
              className="texte-apropos text-4xl relative text-[#c792cf] font-semibold tracking-tighter font-[Yanone Kaffeesatz] after:content-[''] 
              after:absolute after:block after:h-1 after:bg-[#c792cf] 
              after:w-full"
            >
              Livre d'Or
            </span>

            <p className="text-gray-300 text-xs text-center select-none">
              Cette page est réservée aux commentaires, alors faites preuve d'indulgence ou tout simplement vous pouvez me féliciter.
            </p>

            <ul className="w-full grid grid-cols-1 gap-5 md:grid-cols-2">
              <div className="flex items-center flex-col w-auto col-span-2 space-y-8">
                <form
                  onSubmit={sendCommentaire}
                  className="w-full max-w-2xl flex flex-col space-y-4 rounded-lg border border-[#c792cf]/40 bg-[#1f2d32] p-5 shadow-lg"
                >
                  <div className="flex flex-col space-y-2">
                    <label htmlFor="pseudo" className="text-sm font-semibold text-[#c792cf]">
                      Votre pseudo
                    </label>
                    <input
                      id="pseudo"
                      type="text"
                      className="w-full h-12 rounded-md border border-gray-600 bg-[#233238] px-3 text-gray-100 outline-none transition-colors placeholder:text-gray-500 focus:border-[#c792cf] focus:ring-1 focus:ring-[#c792cf]"
                      placeholder="Comment souhaitez-vous être affiché ?"
                      name="pseudo"
                      value={pseudo}
                      onChange={(e) => setPseudo(e.target.value)}
                      required
                    />
                  </div>
                  <div className="flex flex-col space-y-2">
                    <label htmlFor="commentaire" className="text-sm font-semibold text-[#c792cf]">
                      Votre message
                    </label>
                    <textarea
                      id="commentaire"
                      style={{ minHeight: "112px", maxHeight: "350px" }}
                      className="w-full resize-y rounded-md border border-gray-600 bg-[#233238] p-3 text-gray-100 outline-none transition-colors placeholder:text-gray-500 focus:border-[#c792cf] focus:ring-1 focus:ring-[#c792cf]"
                      placeholder="Partagez votre expérience..."
                      name="commentaire"
                      value={commentaire}
                      onChange={(e) => setCommentaire(e.target.value)}
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    disabled={loadingBoutton}
                    className="h-12 rounded-md bg-[#c792cf] px-6 text-lg font-semibold text-[#1f2d32] transition hover:brightness-110 disabled:cursor-not-allowed disabled:opacity-60 md:w-72"
                  >
                    {loadingBoutton ? "En cours..." : "Publier mon message"}
                  </button>
                </form>

                {/* affichier les commentaires */}
                <ul className="w-full flex flex-col border-t border-gray-700 pt-3 space-y-3">
                  {allCommentaire !== null
                    ? allCommentaire.map((comment, id) => (
                        <OneCommentaire key={id} comment={comment} />
                      ))
                    : [12, 6, 8, 10, 9, 2].map((_, id) => (
                        <SkeletonComment key={id} />
                      ))}
                </ul>
              </div>
            </ul>
          </div>
        </div>

        {hauteurScroll > 120 && (
          <button
            type="button"
            onClick={scrollToTop}
            aria-label="Retourner en haut de la page"
            title="Retourner en haut"
            className="fixed bottom-20 right-5 z-40 flex h-12 w-12 items-center justify-center rounded-full border border-[#c792cf]/70 bg-[#1f2d32] text-[#c792cf] shadow-[0_0_16px_rgba(199,146,207,0.25)] transition-all duration-300 hover:-translate-y-1 hover:bg-[#c792cf] hover:text-[#1f2d32] lg:bottom-8 lg:right-8"
          >
            <FaArrowUp className="h-5 w-5" />
          </button>
        )}

        {/* footer */}
        <div className="lg:hidden pb-20">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default LivreDOr;
